import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { ToastModule } from 'primeng/toast';
import { ToastPrimeService } from 'src/app/shared/services/toast-prime.service';

@Component({
  selector: 'z-toaster',
  standalone: true,
  imports: [ToastModule, NgTemplateOutlet],
  templateUrl: './toaster.component.html',
  styleUrl: './toaster.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToasterComponent {
  primeToast = inject(ToastPrimeService);
}
